var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMySuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10114_14311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.151 1.74243H1.68741V80.8476H6.151V1.74243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 11.9697H59.3587V4.81934H0.5V50.7119H52.1736C56.1258 50.7206 59.324 53.9188 59.35 57.8624H82.4913L69.6726 34.9117L82.4913 11.9611L82.5 11.9697Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 57.8623H59.35V11.9871H82.5L69.6726 34.9117L82.5 57.8623Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4766 15.4885C22.5319 15.4885 21.5785 15.8525 20.8592 16.5719L15.6155 21.8156C14.1681 23.263 14.1681 25.6118 15.6155 27.0592L30.4104 41.854L45.2052 27.0592C46.6526 25.6118 46.6526 23.263 45.2052 21.8156L39.9702 16.5719C39.2509 15.8439 38.2975 15.4799 37.3528 15.4799C36.408 15.4799 35.4547 15.8439 34.7266 16.5719L30.419 20.8795L26.1028 16.5633C25.3748 15.8352 24.43 15.4712 23.4766 15.4712",
    fill: "#CC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10114_14311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 79.1052,
    fill: "white",
    transform: "translate(0.5 1.74243)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySuccess);
export default __webpack_public_path__ + "static/media/mySuccess.8d65f51002d97c3e245b97415fcf2adb.svg";
export { ForwardRef as ReactComponent };